var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c(_setup.RoutesListing,{attrs:{"corporateId":parseInt(_vm.companyId),"hideCorporateSelector":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }